// firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
    apiKey: "AIzaSyDRzQVtPb1YOOPKo9UTvygEBwM-JksTj7I",
    authDomain: "explora-san-juan.firebaseapp.com",
    projectId: "explora-san-juan",
    storageBucket: "explora-san-juan.appspot.com",
    messagingSenderId: "737555248093",
    appId: "1:737555248093:web:c6299e7bc35927360b3c34",
    measurementId: "G-NBCVD5723P"
  };


// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);


